import { PageEvent } from '@angular/material/paginator'

export class PageInfoBase {
    pageNumber: number
    pageSize: number
    sortDirection!: string
    sortField!: string

    constructor() {
        this.pageNumber = 0
        this.pageSize = 20
    }

    next(event: PageEvent): void {
        this.pageNumber = event.pageIndex
        this.pageSize = event.pageSize
    }

    rest() {
        this.pageNumber = 0
    }

    resetOrder() {
        this.sortDirection = <any> undefined
        this.sortField = <any> undefined
    }

}

export interface PageInfo extends PageInfoBase { }